import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';

import { IKPIData } from '@vantage-platform/store';

@Component({
  selector: 'vantage-platform-kpi',
  templateUrl: './kpi.component.html',
  styleUrls: ['./kpi.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class KpiComponent implements OnInit {
  @Input() data: IKPIData;

  constructor() {}

  ngOnInit(): void {}
}
